import { render, staticRenderFns } from "./classTest.vue?vue&type=template&id=0e840594&scoped=true&"
import script from "./classTest.vue?vue&type=script&lang=js&"
export * from "./classTest.vue?vue&type=script&lang=js&"
import style0 from "./classTest.vue?vue&type=style&index=0&id=0e840594&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e840594",
  null
  
)

export default component.exports